import { useState, useEffect } from "react";
import "../IconsSettings.scss";
import "./HideUnhidePages.scss";
import { useAuthContext } from "../../../firebase-files/hooks/useAuthContext";
import { useDocument } from "../../../firebase-files/hooks/useDocument";
import { useFirestore } from "../../../firebase-files/hooks/useFirestore";
import { MDBCol, MDBRow, MDBCardText } from "mdb-react-ui-kit";
import ReactSwitch from "react-switch";

const HideUnhidePages = () => {
  const { user } = useAuthContext();
  const { updateDocument } = useFirestore("settings");
  const [pageControlDocState, setPageControlDocState] = useState(null);

  const { document: pageControlDoc, error: pageControlDocerror } = useDocument(
    "settings",
    "pagesControl"
  );

  useEffect(() => {
    setPageControlDocState(pageControlDoc);
  }, [pageControlDoc]);

  const pageTypeLabels = {
    career: "Career",
    home: "Home",
    events: "Events",
    gallery: "Gallery",
    products: "Products",
    returnpolicy: "Return Policy",
    dashboard: "Dashboard",
    adminPanel: "Admin Panel",
    cart: "Cart",
    checkOut: "Checkout",
    about: "About",
    login: "Login",
    orders: "Orders",
    address: "Address",
    // accommodationBooking: "Accommodation Booking",
  };

  const handleToggleChange = async (fieldName, currentValue) => {
    try {
      await updateDocument("pagesControl", {
        [fieldName]: currentValue,
      });
    } catch (error) {
      console.error("Error updating page status:", error);
    }
  };

  return (
    <div className="hide-unhide-pages-parent-div">
      {user && user.role === "admin" && (
        <div className="radio-container menu-and-submenu-table-container">
          <div className="section-title">
            <p>Hide-Unhide Pages : </p>
          </div>

          {Object.entries(pageTypeLabels)
            .sort(([, labelA], [, labelB]) => labelA.localeCompare(labelB))
            .map(([fieldName, label]) => {
              const isFieldAvailable =
                pageControlDocState?.hasOwnProperty(fieldName);
              const currentValue = isFieldAvailable
                ? pageControlDocState[fieldName]
                : false;

              return (
                <div
                  key={fieldName}
                  className="d-flex align-items-center justify-content-between"
                  style={{
                    border: "1px solid grey",
                    borderRadius: "7px",
                    margin: "8px 0px",
                    padding: "8px",
                  }}
                >
                  <div>
                    <h6
                      style={{
                        fontWeight: "700",
                        color: "var(--heading-color)",
                      }}
                    >
                      {label}
                    </h6>
                    <p>Page Visibility</p>
                  </div>

                  {/* ACTIVE INACTIVE SWITCH */}
                  <div style={{ margin: "0px 0px 20px 15px" }}>
                    <MDBRow>
                      <MDBCol className="col-9">
                        <MDBCardText className="text-muted">
                          <div className="d-flex align-items-center mt-2">
                            <ReactSwitch
                              checked={currentValue}
                              onChange={() =>
                                handleToggleChange(fieldName, !currentValue)
                              }
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                          </div>
                        </MDBCardText>
                      </MDBCol>
                    </MDBRow>
                  </div>
                </div>
              );
            })}

          <br />
          <p style={{ fontSize: "13px" }}>
            <span style={{ fontWeight: "bold", color: "var(--red-color)" }}>
              Note :
            </span>
            &nbsp;Page Settings : You can customize the visibility settings for
            the icons on your page according to your preference
          </p>
        </div>
      )}
      <br />
    </div>
  );
};

export default HideUnhidePages;
